import { render } from "./DriverLayout.vue?vue&type=template&id=54683338"
import script from "./DriverLayout.vue?vue&type=script&lang=js"
export * from "./DriverLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__